/**
 * Number of assets a group-B visitor sees on audio browse/category pages
 * before the "Show more" CTA (DEV-5440). Passed as `perPage` to the search
 * hooks so the first fetched page is exactly this size; pages fetched after
 * opting into infinite scroll use the same size.
 *
 * Note: because the variant only resolves client-side, group-B visitors
 * can't reuse the SSR-prefetched default-sized page — the cache keys
 * intentionally differ and the client refetches at this size.
 */
export const SHOW_MORE_VISITOR_PAGE_SIZE = 40;

/**
 * Group-B target for how many stock video assets load before the "Show
 * more" CTA on the stock video homepage and category pages (DEV-5439 /
 * DEV-5441): two 24-asset pages, roughly 16 grid rows versus the default
 * single page's 8. The page auto-fetches the second page while the CTA
 * gate is closed.
 */
export const SHOW_MORE_STOCK_VIDEO_PRE_CTA_ASSETS = 48;
